export const DIALOG_CONTENT_OBJECT = 'filter-container';
export const DIALOG_CONTENT_OBJECT_ID = `#${DIALOG_CONTENT_OBJECT}`;